<template>
  <ion-page>
    <ion-header>
      <LoggedInNav
        :title="'Email'"
        :back="true"
        :backUrl="'/configuracion/datosPersonales'"
      />
    </ion-header>
    <ion-grid class="grid" v-if="step1">
      <ion-row>
        <ion-col class="grid__content">
          <h3 class="subtitle-1 ion-text-center">
            Para continuar, primero debes verificar tu identidad
          </h3>
        </ion-col>
      </ion-row>
      <ion-row class="w-100">
        <ion-col>
          <div>
            <div class="centerCenter">
              <ion-item mode="md">
                <ion-label position="floating" class="labelText"
                  >Contraseña</ion-label
                >
                <ion-input
                  :type="passwordFieldType"
                  name="password"
                  v-model="vv.password.$model"
                  v-bind="password"
                />
                <ion-icon
                  slot="end"
                  :icon="passwordEyeStyle"
                  @click="switchPasswordVisibility"
                  style="margin-top: 20px"
                ></ion-icon>
              </ion-item>
            </div>
          
          <div class="centerCenter">
            <div class="contenedor" v-if="showErrosPassword" style="width: 100%; justify-content: left;">
              <p
                class="error-msg"
                v-if="vv?.password?.$errors[0]?.$message === 'Value is required'"
              >
                Contraseña requerida
              </p>
            </div>
          </div>
          
          <div class="centerCenter" style="margin: 50px 0 5px 0">
          <span class="parrafo-small">
            ¿Olvidaste tu contraseña?
            <span
              style="color: #e33613; font-weight: bold"
              v-on:click="goToRecover"
              >RECUPERAR</span
            >
          </span>
        </div>
        </div>
        </ion-col>
      </ion-row>
      <ion-row class="grid__actions">
        <ion-col>
          <div class="centerCenter">
            <ion-button
            class="btn buttonIniciar"
            expand="block"
            fill="solid"
            :disabled="vv?.password.$dirty == false"
            v-on:click="enviar1"
            >Siguiente</ion-button
            >
          </div>
          
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="grid" v-if="step2">
      <ion-row>
        <ion-col class="grid__content">
          <h3 class="subtitle-1 ion-text-center">
            Elige una nuevo Email para que te enviemos un código de validación
          </h3>
        </ion-col>
      </ion-row>
      <ion-row class="w-100">
        <ion-col>
          <div>
            <div class="centerCenter">
              <ion-item :class="email1Correct ? 'correct' : 'notCorrect'" mode="md">
                <ion-label
                  position="floating"
                  class="labelText"
                  :class="email1Correct ? 'correctLabel' : 'notCorrectLabel'"
                  >Email</ion-label
                >
                <ion-input
                  type="email"
                  name="emailAddress"
                  v-model="vv.emailAddress.$model"
                />
              </ion-item>
            </div>

            <div class="centerCenter">
              <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.emailAddress?.$errors[0]?.$message === 'Value is required'
                  "
                >
                  Email requerido
                </p>
              </div>
            </div>

            <div class="centerCenter">
              <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.emailAddress?.$errors[0]?.$message ===
                    'Value is not a valid email address'
                  "
                >
                  Dirección de email invalida
                </p>
              </div>
            </div>
          
        </div>
        <div style="padding-top: 30px">

          <div class="centerCenter">
            <ion-item :class="email2Correct ? 'correct' : 'notCorrect'" mode="md">
              <ion-label
                position="floating"
                class="labelText"
                :class="email2Correct ? 'correctLabel' : 'notCorrectLabel'"
                >Confirmar email</ion-label
              >
              <ion-input
                type="email"
                name="repeatEmail"
                v-model="vv.repeatEmail.$model"
              />
            </ion-item>
          </div>

          <div class="centerCenter">
            <div class="contenedor" style="width: 100%; justify-content: left;">
              <p
                class="error-msg"
                v-if="vv.repeatEmail.$model !== vv.emailAddress.$model"
              >
                Los correos deben ser iguales
              </p>
            </div>
          </div>

        </div>
        </ion-col>
      </ion-row>
      <ion-row class="grid__actions">
        <ion-col>
          <div class="centerCenter">
            <ion-button
              class="btn buttonIniciar"
              expand="block"
              fill="solid"
              v-on:click="enviar2"
              :disabled="
                vv?.emailAddress?.$errors.length > 0 ||
                vv?.repeatEmail?.$errors.length > 0 ||
                vv?.emailAddress.$dirty == false ||
                vv?.repeatEmail.$dirty == false ||
                vv.repeatEmail.$model !== vv.emailAddress.$model
              "
              >Enviar</ion-button
            >
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="grid" v-if="step3">
      <ion-row>
        <ion-col class="grid__content">
          <h3 class="subtitle-1 ion-text-center">
            Ingresa el codigo de validación enviado a tu Email.
          </h3>
        </ion-col>
      </ion-row>
      <ion-row class="w-100">
        <ion-col>
          <div style="margin-top: 40px">
          <ValidationCode
            @enable-button="enableB($event)"
            @disable-button="fourDigit = false"
            ref="validation"
          />
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 30px 0 50px 0;
          "
        >
          <span class="parrafo-small">
            No recibí el codigo
            <span
              style="color: #e33613; font-weight: bold"
              v-on:click="reenviar"
              >REENVIAR</span
            >
          </span>
        </div>
        </ion-col>
      </ion-row>
      <ion-row class="grid__actions">
        <ion-col>
          <div class="centerCenter">
            <ion-button
              class="btn buttonIniciar"
              expand="block"
              fill="solid"
              v-on:click="openModal"
              :disabled="fourDigit === false"
              >Enviar</ion-button
            >
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import { reactive, toRef } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import {
  IonPage,
  IonCol,
  IonGrid,
  IonRow,
  IonHeader,
  IonButton,
  modalController,
  IonLabel,
  IonInput,
  IonItem,
  toastController
} from "@ionic/vue";
import LoggedInNav from "../../../../components/LoggedInNav.vue";
import ValidationCode from "../../../../components/ValidationCode";
import Modal from "../../../../components/Modals/ModalCambiarEmail.vue";
import AccountService from "../../../../services/account.service";
import { eyeOutline, eyeOffOutline } from "ionicons/icons";
import router from "../../../../router/index";
import { useStore } from "vuex";
export default defineComponent({
  name: "Email",
  components: {
    IonPage,
    IonCol,
    IonGrid,
    IonRow,
    IonHeader,
    IonButton,
    LoggedInNav,
    IonLabel,
    IonInput,
    IonItem,
    ValidationCode
  },
  data() {
    return {
      step1: true,
      showErrosPassword: false,
      passwordFieldType: "password",
      passwordEyeStyle: eyeOffOutline,
      step2: false,
      step3: false,
      email1Correct: false,
      email2Correct: false,
      password: "",
      fourDigit: false,
      enviar1Button: false,
      myCode: "",
    };
  },
  watch: {
    vv() {
      if (
        this.vv.emailAddress.$errors.length === 0 &&
        this.vv.emailAddress.$dirty === true
      ) {
        this.email1Correct = true;
      } else {
        this.email1Correct = false;
      }
      if (
        this.vv.repeatEmail.$errors.length === 0 &&
        this.vv.repeatEmail.$dirty === true
      ) {
        this.email2Correct = true;
      } else {
        this.email2Correct = false;
      }
    },
  },
  setup() {
    const store = useStore();
    const fform = reactive({
      emailAddress: "",
      password: "",
      repeatEmail: "",
    });
    const rules = {
      emailAddress: { required, email },
      password: { required },
      repeatEmail: { required, email },
    };
    const vv = useVuelidate(rules, {
      emailAddress: toRef(fform, "emailAddress"),
      password: toRef(fform, "password"),
      repeatEmail: toRef(fform, "repeatEmail"),
    });

    const onSubmit = () => {
      vv.value.$touch();
      if (vv.value.$invalid) return;
    };
    return {
      store,
      onSubmit,
      vv,
      eyeOutline,
      eyeOffOutline,
    };
  },
  methods: {
    async openModal() {
      const modal = await modalController.create({
        component: Modal,
        mode: "md"
      });
      AccountService.changeEmail({
        email: this.vv.emailAddress.$model,
        token: this.myCode,
      }).then((data) => {
        if (data === "success") {
          this.$store.commit("User/setEmail", this.vv.emailAddress.$model);
          return modal.present();
        }
      });
    },
    switchPasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordEyeStyle =
        this.passwordEyeStyle === eyeOffOutline ? eyeOutline : eyeOffOutline;
    },
    enviar1() {
      this.showErrosPassword = true;
      if (this.vv.password?.$errors.length === 0) {
        AccountService.checkPassword({
          password: this.vv.password.$model,
        }).then((data) => {
          if (data === "success") {
            (this.step1 = false), (this.step2 = true);
          }
        });
      }
    },
    enviar2() {
      AccountService.sendNewEmail({
        email: this.vv.emailAddress.$model,
      }).then((data) => {
        if (data === "success") {
          (this.step1 = false), (this.step2 = false), (this.step3 = true);
        }
      });
    },
    reenviar() {
      AccountService.sendNewEmail({
        email: this.vv.emailAddress.$model,
      }).then((data) => {
        if (data === "success") {
          this.openToastReenviado();
          this.$refs.validation.reenviar();
        }
      });
    },
    goToRecover() {
      router.push("/recuperarPassword");
    },
    enableB(code) {
      this.fourDigit = true;
      this.myCode = code;
    },
    async openToastReenviado() {
      const message = "Código reenviado";
      const toast = await toastController
      .create({
        cssClass: 'success',
        position: 'middle',
        header: 'Éxito',
        message: message,
        duration: 2000
      })
      return toast.present();
    }
  },
});
</script>
<style lang="scss" scoped>
.grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 38px 14px 35px;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
  }

  &__actions {
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    align-items: flex-end;
  }
}

.label {
  display: flex;
  align-items: center;

  img {
    margin-right: 20px;
  }

  h5 {
    margin: 0;
  }
}

ion-item {
  border-radius: 10px 10px 0 0;
  border-bottom: 3px solid #b4b4b4;
  --background: white;
  margin-top: 10px;
  --highlight-color-focused: #d4692700;
   width: 100%;
  max-width: 700px;
}

ion-item.item-has-focus {
  border-bottom: 3px solid #d46927;
}

ion-item.item-has-focus > ion-label {
  color: #d46827;
}
</style>
